function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire93b0"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire93b0"] = parcelRequire;
}
const $7d9f01ff152f00eb$export$f3c6ed4330abfc18 = function() {
    return "#" + ("00000" + Math.floor(Math.random() * 16777216).toString(16)).slice(-6);
};
const $7d9f01ff152f00eb$export$5b36b6f0d685d40 = function(v) {
    var i = Math.floor(v * 6);
    var f = (v * 6 - i + 1) % 1;
    var q = ("0" + Math.round(255 * (1 - f)).toString(16)).slice(-2);
    var t = ("0" + Math.round(255 * f).toString(16)).slice(-2);
    switch((i + 6) % 6){
        case 0:
            return "#FF" + t + "00";
        case 1:
            return "#" + q + "FF00";
        case 2:
            return "#00FF" + t;
        case 3:
            return "#00" + q + "FF";
        case 4:
            return "#" + t + "00FF";
        case 5:
            return "#FF00" + q;
    }
};
const $7d9f01ff152f00eb$export$e54c95be12cf2344 = function(r, g, b) {
    return "#" + ("0" + Math.floor(r).toString(16)).slice(-2) + ("0" + Math.floor(g).toString(16)).slice(-2) + ("0" + Math.floor(b).toString(16)).slice(-2);
};


function $0ce5141a586bd8d5$export$f0a4cb52e779eda4(href) {
    // avoid duplicates
    for(let i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].href === href) return Promise.resolve();
    }
    return new Promise((resolve, reject)=>{
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = href;
        link.onload = resolve;
        link.onerror = reject;
        document.head.appendChild(link);
    });
}
function $0ce5141a586bd8d5$export$4b938d075d59879c(tag, rawProps) {
    const el = document.createElement(tag);
    const { children: children, ...otherProps } = rawProps;
    const props = otherProps;
    for(const key in props){
        if (key === "style") for(const key2 in props.style)el.style[key2] = props.style[key2];
        else if (typeof props[key] === "function" && key[0] === "o" && key[1] === "n") el.addEventListener(key.substr(2), props[key]);
        else el[key] = props[key];
    }
    function addChild(child) {
        if (child instanceof Array) child.forEach(addChild);
        else if (child instanceof Node) el.appendChild(child);
        else if (child) el.appendChild(document.createTextNode(String(child)));
    }
    if (children) addChild(children);
    return el;
}
function $0ce5141a586bd8d5$export$4a80062ca50b57c7(el, className, enabled) {
    const regexp = new RegExp("\\s*" + className, "g");
    if (typeof enabled === "undefined") enabled = !regexp.test(el.className);
    else if (enabled && regexp.test(el.className)) return;
    if (enabled) el.className += " " + className;
    else el.className = el.className.replace(regexp, "");
}


class $c2d7541b81dd5a64$export$2e2bcd8739ae039 {
    constructor(){
        this._listeners = {};
        this._queued = {};
        this._timeout = null;
    }
    on(type, callback) {
        let registered = this._listeners[type];
        if (!registered) {
            registered = [];
            this._listeners[type] = registered;
        }
        registered.push(callback);
    }
    emit(type, arg) {
        const registered = this._listeners[type];
        if (registered) registered.forEach((cb)=>cb.call(this, arg));
    }
    emitOnceAsync(type, arg) {
        this._queued[type] = arg;
        if (!this._timeout) this._timeout = setTimeout(()=>{
            this._timeout = null;
            const queued = this._queued;
            this._queued = {};
            for(const type in queued)this.emit(type, queued[type]);
        }, 0);
    }
    removeListener(type, callback) {
        const registered = this._listeners[type];
        if (registered) {
            const index = registered.indexOf(callback);
            if (index >= 0) registered.splice(index, 1);
        }
    }
}


parcelRequire("cPdJo");
// definition for a point quadtree. Useful every now and again.. especially when working with 2D grids ;)
class $4811c2f0f662c58f$export$2e2bcd8739ae039 {
    constructor(minx, miny, maxx, maxy){
        this.minx = minx;
        this.miny = miny;
        this.maxx = maxx;
        this.maxy = maxy;
        this.midx = (this.minx + this.maxx) / 2;
        this.midy = (this.miny + this.maxy) / 2;
        this.bucket = [];
        this.nw = null;
        this.ne = null;
        this.sw = null;
        this.se = null;
    }
    insert(obj) {
        // first make sure that the object goes inside our region.
        if (obj.x < this.minx || obj.x >= this.maxx || obj.y < this.miny || obj.y >= this.maxy) return false;
        // if we have no children,
        if (!this.nw) {
            // if we have not filled our own bucket, add to it.
            if (this.bucket.length < 5) {
                this.bucket.push(obj);
                return true;
            }
            // if we fill our own bucket, split up.
            this.subdivide();
        }
        // try storing the object in one of our children.
        return this.nw.insert(obj) || this.ne.insert(obj) || this.sw.insert(obj) || this.se.insert(obj);
    }
    subdivide() {
        // split up into four quadrants (child nodes)
        this.nw = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.minx, this.miny, this.midx, this.midy);
        this.ne = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.midx, this.miny, this.maxx, this.midy);
        this.sw = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.minx, this.midy, this.midx, this.maxy);
        this.se = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.midx, this.midy, this.maxx, this.maxy);
        // dump the contents of our bucket into our children
        for(var i = 0; i < this.bucket.length; i++)this.insert(this.bucket[i]);
        this.bucket = null;
    }
    inRegion(minx, miny, maxx, maxy) {
        // check that we overlap with the region
        if (maxx < this.minx || minx >= this.maxx || maxy < this.miny || miny >= this.maxy) return [];
        // if we have no children, return our bucket.
        // I decided not to copy the bucket, for speed reasons.
        if (!this.nw) return this.bucket;
        var found = [];
        // push the contents of our children into the array and return it
        found = found.concat(this.nw.inRegion(minx, miny, maxx, maxy), this.ne.inRegion(minx, miny, maxx, maxy), this.sw.inRegion(minx, miny, maxx, maxy), this.se.inRegion(minx, miny, maxx, maxy));
        return found;
    }
    draw(canvas, ctx, minx, miny, maxx, maxy) {
        var midx = (minx + maxx) / 2;
        var midy = (miny + maxy) / 2;
        if (this.nw) {
            ctx.beginPath();
            ctx.moveTo(minx * canvas.drawWidth, midy * canvas.drawHeight);
            ctx.lineTo(maxx * canvas.drawWidth, midy * canvas.drawHeight);
            ctx.moveTo(midx * canvas.drawWidth, miny * canvas.drawHeight);
            ctx.lineTo(midx * canvas.drawWidth, maxy * canvas.drawHeight);
            ctx.closePath();
            ctx.strokeStyle = "#FF0000";
            ctx.stroke();
            this.nw.draw(canvas, ctx, minx, miny, midx, midy);
            this.ne.draw(canvas, ctx, midx, miny, maxx, midy);
            this.sw.draw(canvas, ctx, minx, midy, midx, maxy);
            this.se.draw(canvas, ctx, midx, midy, maxx, maxy);
        } else for(var i = 0; i < this.bucket.length; i++){
            var p = this.bucket[i];
            var x = minx + (p.x - this.minx) / (this.maxx - this.minx) * (maxx - minx);
            var y = miny + (p.y - this.miny) / (this.maxy - this.miny) * (maxy - miny);
            ctx.fillStyle = "#0000FF";
            ctx.fillRect(x * canvas.drawWidth, y * canvas.drawHeight, 1, 1);
        }
    }
}



class $dc7180c53067d938$export$6a4eb2e7fc9e8903 extends (0, $c2d7541b81dd5a64$export$2e2bcd8739ae039) {
    constructor(capacity){
        super();
        this.data = [];
        this.capacity = capacity;
    }
    map(transform, capacity = Infinity) {
        return this.mapAsync((x, cb)=>cb(transform(x)), null, capacity);
    }
    mapAsync(transform, abort, capacity = Infinity) {
        return this.pipe(new $dc7180c53067d938$var$Transformer(transform, abort, capacity));
    }
    filter(predicate, capacity = Infinity) {
        return this.filterAsync((x, cb)=>cb(predicate(x)), null, capacity);
    }
    filterAsync(predicate, abort, capacity = Infinity) {
        return this.pipe(new $dc7180c53067d938$var$Filter(predicate, abort, capacity));
    }
    forEach(callback) {
        const fill = ()=>{
            while(this.canRead())callback(this.read());
        };
        this.on("can-read", fill);
        fill();
    }
    pipe(dest) {
        const fill = ()=>{
            // TODO: Break this up if the streams have unlimited bandwidth
            while(this.canRead() && dest.canWrite())dest.write(this.read());
        };
        this.on("can-read", fill);
        dest.on("can-write", fill);
        this.on("clear", dest.clear.bind(dest));
        fill();
        return dest;
    }
    clear() {
        this.data = [];
        this.emit("clear");
    }
    canRead() {
        return this.data.length > 0;
    }
    read() {
        const res = this.data.shift();
        if (this.data.length === this.capacity - 1) {
            // This prevents infinite recursion when piping A=>B=>C
            //   where A and C have unlimited bandwidth and B has a capacity of 1:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[can-write B]>...
            // If B has a capacity of greater than 1, this becomes:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)
            //                            >[can-read B]>(pipe B=>C)
            //                            >...
            //   because writing from B does not cause its length to be (capacity-1),
            //   so the [can-write B] event does not get triggered during (pipe B=>C).
            // This delays the [can-write B] event if capacity === 1, so it becomes:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[setTimeout]
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[setTimeout]
            //   ...
            // This will be slower, but hey, that's what you get ¯\_(ツ)_/¯
            if (this.capacity === 1) this.emitOnceAsync("can-write");
            else this.emit("can-write");
        }
        return res;
    }
    canWrite() {
        return this.data.length < this.capacity;
    }
    write(chunk) {
        if (this.canWrite()) {
            this.data.push(chunk);
            if (this.data.length === 1) this.emit("can-read");
        }
    }
}
class $dc7180c53067d938$var$Transformer extends $dc7180c53067d938$export$6a4eb2e7fc9e8903 {
    constructor(transform, abort, capacity){
        super(capacity);
        this.transform = transform;
        this.abort = abort;
        this.numReady = 0;
    }
    canRead() {
        return this.numReady > 0;
    }
    read() {
        this.numReady--;
        return super.read();
    }
    write(chunk) {
        super.write(chunk);
        this.transform(chunk, (data)=>{
            const index = this.data.indexOf(chunk);
            this.data.splice(index, 1);
            this.data.splice(this.numReady, 0, data);
            this.numReady++;
            if (this.numReady === 1) this.emit("can-read");
        });
    }
    clear() {
        if (this.abort) for(let i = this.numReady; i < this.data.length; i++)this.abort(this.data[i]);
        super.clear();
    }
}
class $dc7180c53067d938$var$Filter extends $dc7180c53067d938$export$6a4eb2e7fc9e8903 {
    constructor(predicate, abort, capacity){
        super(capacity);
        this.predicate = predicate;
        this.abort = abort;
    }
    write(chunk) {
        this.predicate(chunk, (x)=>x && super.write(chunk));
    }
    clear() {
        if (this.abort) this.data.forEach((data)=>this.abort(data));
        super.clear();
    }
}


function $c731a29915c32ed7$export$1391212d75b2ee65(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $c731a29915c32ed7$export$d02631cccf789723(from, to, step) {
    if (typeof to === "undefined") {
        to = from;
        from = 0;
    }
    if (typeof step === "undefined") step = Math.sign(to - from);
    if (step === 0) return [];
    const res = [];
    while(step > 0 ? to > from : to < from){
        res.push(from);
        from += step;
    }
    return res;
}


const $d2433c734b6cef7c$export$3d8c2f653ac9d0b9 = document.getElementById.bind(document);
const $d2433c734b6cef7c$export$9fc9dd311300f9ff = function(canvas, context, scaleContext) {
    var devicePixelRatio = window.devicePixelRatio || 1;
    var backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
    var scale = devicePixelRatio / backingStoreRatio;
    canvas.style.width = canvas.width + "px";
    canvas.style.height = canvas.height + "px";
    canvas.drawWidth = canvas.width;
    canvas.drawHeight = canvas.height;
    $d2433c734b6cef7c$export$59b33278b5b2fc8a(canvas, context, canvas.width * scale, canvas.height * scale, scaleContext);
    return scale;
};
const $d2433c734b6cef7c$export$59b33278b5b2fc8a = function(canvas, context, width, height, scaleContext) {
    if (scaleContext === undefined) scaleContext = true;
    canvas.width = width;
    canvas.height = height;
    if (!scaleContext || !canvas.drawWidth || !canvas.drawHeight) {
        canvas.drawWidth = width;
        canvas.drawHeight = height;
    }
    if (scaleContext) {
        var scalex = width / canvas.drawWidth;
        var scaley = height / canvas.drawHeight;
        canvas.scalex = scalex;
        canvas.scaley = scaley;
        if (context instanceof CanvasRenderingContext2D) context.scale(scalex, scaley);
    }
};
const $d2433c734b6cef7c$export$98b5291b42c669ef = function(el, preferredWidth, preferredHeight, onresize) {
    preferredWidth = preferredWidth || el.clientWidth;
    preferredHeight = preferredHeight || el.clientHeight;
    onresize = onresize || function() {};
    var preferredRatio = preferredWidth / preferredHeight;
    var resize = function() {
        var style = window.getComputedStyle(el.parentElement, null);
        var width = parseInt(style.getPropertyValue("width"));
        var height = parseInt(style.getPropertyValue("height"));
        var newwidth = Math.min(width, preferredWidth);
        var newheight = Math.min(height, preferredHeight);
        if (newwidth > preferredRatio * newheight) newwidth = Math.floor(preferredRatio * newheight);
        else newheight = Math.floor(newwidth / preferredRatio);
        el.style.width = newwidth + "px";
        el.style.height = newheight + "px";
        onresize(el);
    };
    resize();
    window.addEventListener("resize", resize);
};
const $d2433c734b6cef7c$export$8b1a570463671010 = function(canvas, evt) {
    var x, y;
    // var pressed;
    if (evt instanceof MouseEvent) {
        x = evt.clientX;
        y = evt.clientY;
    // pressed = ~evt.buttons;
    } else if (window.TouchEvent && evt instanceof TouchEvent) {
        var touch = evt.changedTouches[0];
        x = touch.clientX;
        y = touch.clientY;
    // pressed = true;
    }
    var rect = canvas.getBoundingClientRect();
    return {
        x: (x - rect.left) * (canvas.drawWidth / canvas.clientWidth),
        y: (y - rect.top) * (canvas.drawHeight / canvas.clientHeight)
    };
};
const $d2433c734b6cef7c$export$1162121ddfdb1f6f = function(evt) {
    if (window.TouchEvent && evt instanceof TouchEvent) {
        if (evt.touches.length < 2) evt.preventDefault();
    }
};
function $d2433c734b6cef7c$export$9c30223ca0a664fb(el, obj, attr, cb = function() {}, options = {
    instant: true
}) {
    var setter = null;
    if (el.tagName === "INPUT") {
        if ("jscolor" in el) {
            // RGB color
            if (obj[attr] instanceof Array) {
                setter = ([r, g, b])=>el.jscolor.fromRGB(r, g, b);
                el.addEventListener("change", function() {
                    cb(obj[attr] = el.jscolor.rgb.map(Math.floor));
                });
            // Hex color
            } else {
                setter = (x)=>x && el.jscolor.fromString(x.replace(/^#/, ""));
                el.addEventListener("change", function() {
                    cb(obj[attr] = el.value ? "#" + el.jscolor.toString() : null);
                });
            }
        } else if (el.type === "checkbox") {
            setter = (x)=>el.checked = x;
            el.addEventListener("click", ()=>cb(obj[attr] = el.checked));
        // number input
        } else if (typeof obj[attr] === "number") {
            setter = (x)=>el.value = String(x);
            el.addEventListener(options.instant ? "input" : "change", function() {
                var value = +el.value;
                if (!isNaN(value)) cb(obj[attr] = value);
            });
            el.addEventListener("blur", ()=>el.value = String(obj[attr]));
        // string input
        } else {
            setter = (x)=>el.value = x;
            el.addEventListener(options.instant ? "input" : "change", function() {
                cb(obj[attr] = el.value);
            });
        }
    // select
    } else if (el.tagName === "SELECT") {
        setter = (x)=>el.value = x;
        el.addEventListener("change", ()=>cb(obj[attr] = el.value));
    }
    setter(obj[attr]);
    return (x)=>{
        obj[attr] = x;
        setter(x);
    };
}
function $d2433c734b6cef7c$export$bfb71cb8713b8641(obj, map) {
    var res = {};
    for(var key in map){
        var val = map[key];
        if (!(val instanceof Array)) val = [
            val
        ];
        res[key] = $d2433c734b6cef7c$export$9c30223ca0a664fb(val[0], obj, key, val[1], val[2]);
    }
    return res;
}
function $d2433c734b6cef7c$export$7d15b64cf5a3a4c4(num, min, max) {
    return Math.max(min, Math.min(num, max));
}
const $d2433c734b6cef7c$export$bdbb68221349f475 = function(minx, miny, width, height, r) {
    var r2 = r * r;
    var maxx = minx + width;
    var maxy = miny + height;
    var j, k;
    var points = [
        {
            x: Math.random() * width + minx,
            y: Math.random() * height + miny
        }
    ];
    var tree = new (0, $4811c2f0f662c58f$export$2e2bcd8739ae039)(minx, miny, maxx, maxy);
    var active = [];
    // start with a single, randomly placed point
    active.push(points[0]);
    tree.insert(points[0]);
    while(active.length > 0){
        // choose a random point that has free space around it
        var ind = Math.floor(Math.random() * active.length);
        var pt = active[ind];
        var acceptable = false;
        // do 30 random points before we give up
        for(k = 0; k < 30; k++){
            acceptable = true;
            // create a random point near to the current point
            var d = Math.random() * r + r;
            var theta = Math.random() * 2 * Math.PI;
            var px = pt.x + d * Math.cos(theta);
            var py = pt.y + d * Math.sin(theta);
            // if the point is out of bounds, it cannot be placed. Continue on.
            if (px < minx || px >= maxx || py < miny || py >= maxy) {
                acceptable = false;
                continue;
            }
            // get points close to the newly created one
            var nearby = tree.inRegion(px - r, py - r, px + r, py + r);
            for(j = 0; j < nearby.length; j++){
                var dx = px - nearby[j].x;
                var dy = py - nearby[j].y;
                // if we are too close to a neighbor, this point cannot be placed
                if (dx * dx + dy * dy < r2) {
                    acceptable = false;
                    break;
                }
            }
            // if there are no neighbors that are too close, and we are in bounds
            if (acceptable) {
                var newpt = {
                    x: px,
                    y: py
                };
                // insert into the tree and the active points list
                tree.insert(newpt);
                points.push(newpt);
                active.push(newpt);
                break;
            }
        }
        // if we could not place a point, assume the area around this point is filled.
        // remove the current point from the active list.
        if (!acceptable) active.splice(ind, 1);
    }
    // var cvs = $('draw-canvas');
    // var ctx = cvs.getContext('2d');
    // for (i = 0; i < points.length; i++) {
    //   for (j = 0; j < points.length; j++) {
    //     ctx.fillRect(cvs.drawWidth / 2 + (points[j].x - points[i].x),
    //       cvs.drawHeight / 2 + (points[j].y - points[i].y), 1, 1);
    //   }
    // }
    // tree.draw(cvs, ctx, 0, 0, 1, 1);
    return points;
};



const $cc9fb14b9658e054$export$14c2e5f633eb13e7 = function(canvas, attributes) {
    var gl = null;
    try {
        gl = canvas.getContext("webgl", attributes) || canvas.getContext("experimental-webgl", attributes);
    } catch (e) {
    // not supported; return null
    }
    if (!gl) console.log("Couldn't get webGL");
    return gl;
};
const $cc9fb14b9658e054$export$d980ed1a564bfd2d = function(gl, vertSource, fragSource) {
    var program = null;
    var vertShader = gl.createShader(gl.VERTEX_SHADER);
    var fragShader = gl.createShader(gl.FRAGMENT_SHADER);
    try {
        gl.shaderSource(vertShader, vertSource);
        gl.shaderSource(fragShader, fragSource);
        gl.compileShader(vertShader);
        gl.compileShader(fragShader);
        if (!gl.getShaderParameter(vertShader, gl.COMPILE_STATUS)) throw "Could not compile vertex shader:\n\n" + gl.getShaderInfoLog(vertShader);
        if (!gl.getShaderParameter(fragShader, gl.COMPILE_STATUS)) throw "Could not compile fragment shader:\n\n" + gl.getShaderInfoLog(fragShader);
        program = gl.createProgram();
        gl.attachShader(program, vertShader);
        gl.attachShader(program, fragShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            gl.deleteProgram(program);
            program = null;
            throw "Could not compile program:\n\n" + gl.getProgramInfoLog(program);
        }
    } catch (e) {
        console.log(e);
    } finally{
        // we can (and should) delete the shaders
        // even if the shaders compiled and the program linked
        gl.deleteShader(vertShader);
        gl.deleteShader(fragShader);
    }
    return program;
};


var $c9543f0221d1b20c$exports = {};
$c9543f0221d1b20c$exports = "#define GLSLIFY 1\nattribute vec2 position;\n\nvoid main() {\n	gl_Position = vec4(position, 0, 1);\n}";



const $887300431d168f2c$var$MAX_EDGES = 16;
var $887300431d168f2c$export$2e2bcd8739ae039 = `
#if GL_FRAGMENT_PRECISION_HIGH == 1
  precision highp float;
#else
  precision mediump float;
#endif

#define MAX_EDGES ${$887300431d168f2c$var$MAX_EDGES}

uniform vec4 edges[MAX_EDGES];
uniform int num_edges;
uniform float sensitivity;
uniform float scale;

float lineDist(vec4 l, vec2 p) {
  vec2 t = l.zw - l.xy;
  float l2 = t.x*t.x + t.y*t.y;

  vec2 da = p - l.xy;

  float d = dot(t, da);

  if (d <= 0.0) {
    return length(da);
  } else if (d >= l2) {
    return length(p - l.zw);
  } else {
    return sqrt(da.x*da.x + da.y*da.y - (d * d) / l2);
  }
}

vec3 hsv2rgb(vec3 c)
{
  vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
  vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
  return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
}

void main() {
  float val;
  float dists[MAX_EDGES];
  bool brokeearly;

  ${// unroll loop to support "dynamic" indexing
(0, $c731a29915c32ed7$export$d02631cccf789723)($887300431d168f2c$var$MAX_EDGES).map((i)=>`
  if (${i} < num_edges) {
    val = lineDist(edges[${i}],  gl_FragCoord.xy / scale);

    brokeearly = false;
    for (int j = ${i}; j > 0; j--) {
      if (dists[j - 1] <= val) {
        dists[j] = val;
        brokeearly = true;
        break;
      }
      dists[j] = dists[j - 1];
    }

    if (!brokeearly) {
      dists[0] = val;
    }
  }
  `).join("\n")}

  int len = num_edges;
  vec3 color = vec3(1.0, 1.0, 1.0);
  float diff, fade;

  for (int i=0; i < MAX_EDGES; i++) {
    if (i > num_edges - 2) break;

    len--;

    for (int j=0; j < MAX_EDGES; j++) {
      if (j >= len) break;

      dists[j] = dists[j+1] - dists[j];

      if (j == 0) diff = abs(dists[0]);
      else diff = max(diff, abs(dists[j]));
    }

    fade = clamp(float(num_edges) * sensitivity / diff, 0.0, 1.0);
    color = mix(
      color,
      hsv2rgb(vec3(float(num_edges - 2 - i) / float(MAX_EDGES), fade, 1.0)),
      fade
    );
  }

  gl_FragColor = vec4(color, 1.0);
}`;


window.onload = function() {
    var drawCanvas = (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("draw-canvas");
    var glCanvas = (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("gl-canvas");
    var drawContext = drawCanvas.getContext("2d");
    var gl = (0, $cc9fb14b9658e054$export$14c2e5f633eb13e7)(glCanvas, {
        preserveDrawingBuffer: true
    });
    var nodes, edges;
    // used in redrawing to determine what has changed and needs to be updated.
    var updates = {
        mouseMotion: false,
        mousePress: false,
        mouseRelease: false,
        mouseEnter: false,
        mouseLeave: false,
        nodesChanged: false,
        edgesChanged: false,
        selection: false,
        deselection: false,
        graph: false,
        background: false,
        setAll: function(b) {
            this.mouseMotion = this.mousePress = this.mouseRelease = this.mouseEnter = this.mouseLeave = this.nodesChanged = this.edgesChanged = this.selection = this.deselection = this.graph = this.background = b;
        }
    };
    var positionAttrib;
    var bgbuffer;
    var uniforms = {
        edges: null,
        nEdges: null,
        sensitivity: null,
        scale: null
    };
    var glReady = false;
    var glFrameQueued = false;
    var nearestNode;
    var selectedNode;
    var createdEdge;
    var mouse;
    var options = {
        nodeSize: 10,
        edgeWidth: 1,
        sensitivity: 8,
        showNodes: true,
        showEdges: true,
        edgeDists: false,
        constantUpdates: true
    };
    var inputs = {
        sensitivityinput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("sensitivityinput"),
        sncheck: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("shownodes"),
        secheck: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("showedges"),
        edcheck: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("edgedists"),
        upcheck: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("updates")
    };
    init();
    function init() {
        (0, $d2433c734b6cef7c$export$9fc9dd311300f9ff)(drawCanvas, drawContext);
        var scale = (0, $d2433c734b6cef7c$export$9fc9dd311300f9ff)(glCanvas, gl);
        var canvases = (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("canvases");
        (0, $d2433c734b6cef7c$export$98b5291b42c669ef)(canvases, 500, 500, function(el) {
            drawCanvas.style.width = glCanvas.style.width = canvases.style.width;
            drawCanvas.style.height = glCanvas.style.height = canvases.style.height;
        });
        var graph = connectedGraph(drawCanvas.drawWidth, drawCanvas.drawHeight, 4);
        nodes = graph.nodes;
        edges = graph.edges;
        // webGL setup for background drawing
        var program = (0, $cc9fb14b9658e054$export$d980ed1a564bfd2d)(gl, (0, (/*@__PURE__*/$parcel$interopDefault($c9543f0221d1b20c$exports))), (0, $887300431d168f2c$export$2e2bcd8739ae039));
        gl.useProgram(program);
        positionAttrib = gl.getAttribLocation(program, "position");
        uniforms.edges = gl.getUniformLocation(program, "edges[0]");
        uniforms.nEdges = gl.getUniformLocation(program, "num_edges");
        uniforms.sensitivity = gl.getUniformLocation(program, "sensitivity");
        uniforms.scale = gl.getUniformLocation(program, "scale");
        gl.uniform1f(uniforms.scale, scale);
        glReady = true;
        redrawBackground();
        bgbuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, bgbuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
            -1,
            -1,
            1.0,
            -1,
            -1,
            1.0,
            -1,
            1.0,
            1.0,
            -1,
            1.0,
            1.0
        ]), gl.STATIC_DRAW);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        gl.clearColor(0.0, 0.0, 0.0, 0.0);
        // we want to update te first time we draw, so just... update everything
        updates.setAll(true);
        nearestNode = null;
        selectedNode = null;
        createdEdge = null;
        mouse = {
            x: 0,
            y: 0,
            inside: false
        };
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.sensitivityinput, options, "sensitivity", redrawBackground);
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.sncheck, options, "showNodes", redrawGraph);
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.secheck, options, "showEdges", redrawGraph);
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.edcheck, options, "edgeDists");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.upcheck, options, "constantUpdates");
        drawCanvas.addEventListener("mousedown", mousedown);
        drawCanvas.addEventListener("mouseup", mouseup);
        drawCanvas.addEventListener("mouseenter", mouseenter);
        drawCanvas.addEventListener("mouseleave", mouseleave);
        drawCanvas.addEventListener("mousemove", mousemove);
        drawCanvas.addEventListener("touchstart", mousedown);
        drawCanvas.addEventListener("touchend", mouseleave);
        drawCanvas.addEventListener("touchmove", mousemove);
        window.addEventListener("keydown", keydown);
        draw();
    }
    function draw() {
        // we will update the background if:
        //  - we are drawing the background
        //  - the graph edges have changed, or we have deselected a node,
        //  implying that the edges may have changed
        //  - constant updates are turned on, or the update is not due to
        //  mouse motion or pressing. So we update on mouse release, and
        //  on any other updates (key press, checkbox, etc.)
        var bgchanged = updates.background || (updates.edgesChanged || updates.deselection) && (options.constantUpdates || !updates.mouseMotion && !updates.mousePress);
        // we need to redraw any time the graph itself changes
        var graphchanged = updates.graph || updates.nodesChanged || updates.edgesChanged;
        // we ned to redraw if we are drawing edge distances,
        // and the mouse moved, entered, or exited the canvas
        var distschanged = options.edgeDists && (updates.mouseMotion || updates.mouseEnter || updates.mouseLeave);
        // reset the updates
        updates.setAll(false);
        // if the background changed, we need to redraw the webgl canvas
        if (bgchanged && glReady && edges.length <= 16) // we only want to use webGL when a refresh occurs, even though
        // draw() may be called more often than that. We request one
        // animation frame, and then wait until that one finishes before
        // requesting another using a boolean flag.
        {
            if (!glFrameQueued) {
                glFrameQueued = true;
                requestAnimationFrame(drawBackground);
            }
        }
        // if the graph or edges changed, we need to redraw the 2d canvas
        if (graphchanged || distschanged) {
            drawContext.clearRect(0, 0, drawCanvas.drawWidth, drawCanvas.drawHeight);
            // draw the edges first, so they don't overlap the nodes
            if (options.showEdges) edges.forEach(function(edge) {
                drawContext.beginPath();
                drawContext.moveTo(edge.a.x, edge.a.y);
                drawContext.lineTo(edge.b.x, edge.b.y);
                drawContext.closePath();
                drawContext.strokeStyle = edge.color;
                drawContext.lineWidth = options.edgeWidth;
                drawContext.stroke();
            });
            // now draw the nodes
            if (options.showNodes) nodes.forEach(function(node) {
                drawContext.beginPath();
                drawContext.arc(node.x, node.y, options.nodeSize, 0, 2 * Math.PI);
                drawContext.closePath();
                // black fill, white stroke
                drawContext.fillStyle = "#000000";
                drawContext.strokeStyle = "#FFFFFF";
                drawContext.lineWidth = 1;
                drawContext.fill();
                drawContext.stroke();
            });
            // draw the edge distances only if the mouse is inside the canvas
            if (options.edgeDists && mouse.inside) for(var i = 0; i < edges.length; i++){
                var ldist = edges[i].distance(mouse);
                drawContext.beginPath();
                drawContext.arc(mouse.x, mouse.y, ldist, 0, 2 * Math.PI);
                drawContext.closePath();
                drawContext.strokeStyle = edges[i].color;
                drawContext.lineWidth = 1;
                drawContext.stroke();
            }
        }
    }
    function drawBackground() {
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.uniform1i(uniforms.nEdges, edges.length);
        gl.uniform1f(uniforms.sensitivity, options.sensitivity);
        var uEdges = [];
        for(var i = 0; i < edges.length; i++){
            var edge = edges[i];
            uEdges.push(edge.a.x, drawCanvas.drawHeight - edge.a.y, edge.b.x, drawCanvas.drawHeight - edge.b.y);
        }
        gl.uniform4fv(uniforms.edges, uEdges);
        gl.bindBuffer(gl.ARRAY_BUFFER, bgbuffer);
        gl.enableVertexAttribArray(positionAttrib);
        gl.vertexAttribPointer(positionAttrib, 2, gl.FLOAT, false, 0, 0);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        glFrameQueued = false;
    }
    function redrawGraph() {
        updates.graph = true;
        draw();
    }
    function redrawBackground() {
        updates.background = true;
        draw();
    }
    function findNearestNode() {
        var minDist = Number.POSITIVE_INFINITY;
        var dist;
        for(var i = 0; i < nodes.length; i++){
            dist = nodes[i].distance(mouse);
            if (dist < minDist) {
                minDist = dist;
                nearestNode = nodes[i];
            }
        }
    }
    function Node(x, y) {
        this.x = x;
        this.y = y;
    }
    Node.prototype.distance = function(coord) {
        var dx = coord.x - this.x;
        var dy = coord.y - this.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Node.prototype.nearby = function(coord, dist) {
        var dx = coord.x - this.x;
        var dy = coord.y - this.y;
        return dx * dx + dy * dy < dist * dist;
    };
    Node.prototype.move = function(coord) {
        this.x = coord.x;
        this.y = coord.y;
    };
    function Edge(a, b, color) {
        this.a = a;
        this.b = b;
        this.color = color;
    }
    Edge.prototype.distance = function(p) {
        var tx = this.b.x - this.a.x;
        var ty = this.b.y - this.a.y;
        var l2 = tx * tx + ty * ty;
        var dax = p.x - this.a.x;
        var day = p.y - this.a.y;
        var dbx = p.x - this.b.x;
        var dby = p.y - this.b.y;
        var t = tx * dax + ty * day;
        if (t <= 0) return Math.sqrt(dax * dax + day * day);
        else if (t >= l2) return Math.sqrt(dbx * dbx + dby * dby);
        else return Math.sqrt(dax * dax + day * day - t * t / l2);
    };
    function mousedown(evt) {
        (0, $d2433c734b6cef7c$export$1162121ddfdb1f6f)(evt);
        var mousepos = (0, $d2433c734b6cef7c$export$8b1a570463671010)(drawCanvas, evt);
        mouse.x = mousepos.x;
        mouse.y = mousepos.y;
        findNearestNode();
        // select a node if we are over it
        if (nearestNode.nearby(mouse, options.nodeSize)) {
            selectedNode = nearestNode;
            updates.selection = true;
        }
        // if we ctrl clicked, create a node or edge
        if (evt.ctrlKey || evt.metaKey) {
            // we are not over an existing node, so we will create a new node
            if (selectedNode === null) {
                nearestNode = new Node(mouse.x, mouse.y, 10);
                nodes.push(nearestNode);
                updates.nodesChanged = true;
            // we will create an edge from the existing node
            } else {
                var node = new Node(mouse.x, mouse.y, 10);
                createdEdge = new Edge(node, selectedNode, (0, $7d9f01ff152f00eb$export$f3c6ed4330abfc18)());
                // we select the new node, but don't add it to the nodes list,
                // because we don't actually know if we want to add it yet.
                // we may just connect this edge to an existing node instead.
                selectedNode = node;
                edges.push(createdEdge);
                updates.edgesChanged = true;
            }
        }
        updates.mousePress = true;
        draw();
    }
    function mouseup(evt) {
        (0, $d2433c734b6cef7c$export$1162121ddfdb1f6f)(evt);
        // if we were creating an edge, finish it
        if (createdEdge !== null) {
            // if we are over an existing node, connect the edge to that node
            if (nearestNode.nearby(mouse, options.nodeSize)) {
                createdEdge.a = nearestNode;
                updates.edgesChanged = true;
            // otherwise, place a 'new' node down that connects to the edge
            } else {
                nodes.push(selectedNode);
                nearestNode = selectedNode;
                updates.nodesChanged = true;
            }
            createdEdge = null;
        }
        if (selectedNode !== null) updates.deselection = true;
        updates.mouseRelease = true;
        // release the selected node
        selectedNode = null;
        draw();
    }
    function mousemove(evt) {
        (0, $d2433c734b6cef7c$export$1162121ddfdb1f6f)(evt);
        var mousepos = (0, $d2433c734b6cef7c$export$8b1a570463671010)(drawCanvas, evt);
        mouse.x = mousepos.x;
        mouse.y = mousepos.y;
        findNearestNode();
        // if we are dragging a node, move it
        if (selectedNode !== null) {
            selectedNode.move(mouse);
            updates.nodesChanged = true;
            updates.edgesChanged = true;
        }
        updates.mouseMotion = true;
        draw();
    }
    function keydown(evt) {
        // 'q', backspace, delete
        if (evt.keyCode == 81 || evt.keyCode == 8 || evt.keyCode == 46) {
            var i; // delete a node if we are over it
            if (nearestNode.nearby(mouse, options.nodeSize)) {
                var index = nodes.indexOf(nearestNode);
                nodes.splice(index, 1);
                updates.nodesChanged = true;
                // delete any edges connected to the node
                for(i = 0; i < edges.length; i++){
                    var edge = edges[i];
                    if (edge.a == nearestNode || edge.b == nearestNode) {
                        edges.splice(i, 1);
                        updates.edgesChanged = true;
                        i--;
                    }
                }
                findNearestNode();
            // we are not over a node, look for edges
            } else for(i = 0; i < edges.length; i++){
                var ldist = edges[i].distance(mouse);
                // if we are within 4 pixels, delete the edge
                if (ldist < 4) {
                    edges.splice(i, 1);
                    updates.edgesChanged = true;
                    break;
                }
            }
        }
        draw();
    }
    function mouseenter(evt) {
        mouse.inside = true;
        updates.mouseEnter = true;
        draw();
    }
    function mouseleave(evt) {
        mouse.inside = false;
        updates.mouseLeave = true;
        mouseup(evt);
    }
    function connectedGraph(width, height, n) {
        var nodes = [];
        var edges = [];
        for(var i = 0; i < n; i++){
            var node = new Node(width / 2 + Math.sin(2 * Math.PI * i / n) * (width / 4), height / 2 + Math.cos(2 * Math.PI * i / n) * (height / 4));
            nodes[i] = node;
            for(var j = 0; j < i; j++)edges[edges.length] = new Edge(node, nodes[j], (0, $7d9f01ff152f00eb$export$f3c6ed4330abfc18)());
        }
        return {
            nodes: nodes,
            edges: edges
        };
    }
};


//# sourceMappingURL=index.d2ce0d23.js.map
